import { Component, Inject, OnInit } from '@angular/core';
import { RmsModule } from '@rms';
import { Column } from '@interfaces';
import { LedgerService } from '@services';
import { RMS_PULLDOWN_DATA } from '../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';

@Component({
  selector: 'app-ledger-transaction-detail',
  imports: [RmsModule],
  templateUrl: './ledger-transaction-detail.component.html',
  styleUrl: './ledger-transaction-detail.component.scss'
})
export class LedgerTransactionDetailComponent implements OnInit {
  Transaction: any = null;
  Payments: any[] = [];
  Orders: any[] = [];
  Loading = true;
  ErrorMessage = '';

  PaymentColumns: Column[] = [
    { label: 'Payment', key: 'OrderPaymentID', width: 10 },
    { label: 'Order', key: 'OrderID', width: 10 },
    { label: 'Method', key: 'PaymentMethodName', width: 14 },
    { label: 'Status', key: 'StatusName', width: 10 },
    { label: 'Amount', key: 'Amount', type: 'currency', width: 12, align: 'right' },
    { label: 'Entered', key: 'EntryDate', type: 'date', width: 11 },
    { label: 'Posted', key: 'PostingDate', type: 'date', width: 11 },
    { label: 'Notes', key: 'Notes', width: 22 }
  ];

  OrderColumns: Column[] = [
    { label: 'Order', key: 'OrderID', width: 12 },
    { label: 'Customer', key: 'CompanyName', width: 30 },
    { label: 'Sale Date', key: 'SaleDate', type: 'date', width: 14 },
    { label: 'Pickup Date', key: 'PickupDate', type: 'date', width: 14 },
    { label: 'Date Paid', key: 'DatePaid', type: 'date', width: 14 },
    { label: 'Status', key: 'StatusName', width: 16 }
  ];

  constructor(@Inject(RMS_PULLDOWN_DATA) private data: { TransactionID: number }, private ledger: LedgerService) { }

  ngOnInit() {
    this.ledger.getTransactionDetail(this.data.TransactionID).subscribe({
      next: (result) => {
        this.Loading = false;
        this.Transaction = result?.transaction || null;
        this.Payments = result?.payments || [];
        this.Orders = result?.orders || [];
      },
      error: (err) => {
        this.Loading = false;
        this.ErrorMessage = err?.error?.error || err?.message || 'Failed to load ledger entry.';
      }
    });
  }

  get References(): string {
    const t = this.Transaction;
    if (!t) return '—';
    return [
      t.JournalNumber ? `Journal ${t.JournalNumber}` : '',
      t.RoyalNYInvoiceNumber ? `Invoice ${t.RoyalNYInvoiceNumber}` : '',
      t.MiscellaneousInvoiceNumber ? `Misc invoice ${t.MiscellaneousInvoiceNumber}` : '',
      t.CheckNumber ? `Check ${t.CheckNumber}` : '',
      t.ChargeLogID ? `Charge log ${t.ChargeLogID}` : ''
    ].filter(Boolean).join(' · ') || '—';
  }
}
